var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accepted-brands"},_vm._l((_vm.brands),function(brand){return _c('SvgImage',{staticClass:"accepted-brands__image",attrs:{"icon":brand,"width":"30","height":"30"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }